<template lang="pug">
  .crud
    div(v-if="has_permission")
      modal-customers(:form='form', :is-add='isModalAdd')
      modal-employees(:form='form')
      modal-show-employees(:employeershow='employeershow')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
            div
              h2 {{ $t('strings.customers') }}:
              span {{ $t('strings.description_view', {attribute: $t('strings.customers')}) }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              vm-button(icon="plus" @click="addCustomer" v-if="add_customer_permission") {{ $t('strings.add') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteCustomersConfirm" :disabled="!enabledDelete" v-if="!$auth.check('Customer')")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(multiple v-model="selected"  max-height="350px" :data="customers")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                  div
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columns" v-model="filters.orderBy" @change="changeOrderBy(filters)" size="small" width="200px" :serializer="item => $t('customers.'+ item)")
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('customers.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    div(@click="showEmployers(data[indextr])")
                      slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                      slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'website'") {{data[indextr][column]}}
                      slot(v-if="column == 'website'") {{data[indextr][column] && data[indextr][column] != 'undefined' ? data[indextr][column] : '-'}}
                      vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
                  vm-td
                  vm-dropdown(v-if="add_customer_permission" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editCustomer(data[indextr])")
                        vm-icon(icon="edit-outline")
                        slot &nbsp;{{ $t('users.edit_customer') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="addEmployee(data[indextr])")
                        vm-icon(icon="plus-outline")
                        slot &nbsp;{{ $t('employees.add') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="$router.push(`/customers/${data[indextr]['id']}/employees`)")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('employees.view') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteCustomerConfirm(data[indextr])" v-if="$auth.check('Admin')")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t( 'strings.delete') }}
            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            transition(name="enter")
              .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'Customers',
  components: {
    ModalCustomers: () => import('@/components/modals/ModalCustomers.vue'),
    ModalEmployees: () => import('@/components/modals/ModalEmployees.vue'),
    ModalShowEmployees: () => import('@/components/modals/ModalShowEmployees.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    currentPage: 1,
    employeershow: [],
    isModalAdd: true,
    form: {},
    has_permission: true,
    add_customer_permission: true,
    selected: [],
    columns: [
      'name',
      'contact',
      'email',
      'phone',
      'website'
    ],
    columnsOrderBy: [
      // Nota: Solo si columnas tienen atributos
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Pagado',
        value: 2,
        color: 'warning'
      }
    ],
    filters: {
      where: {
        name: '',
        contact: '',
        email: '',
        param: ''
      },
      whereIn: {
        status: []
      },
      whereBetween: {
        priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {},
    flags: []
  }),
  async created () {
    this.checkPermissionView('customers.index')
    this.filtersClear = parseVuexObject(this.filters)
    await this.getCustomers(1).then(() => {
      this.getVariables()
    })
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deleteCustomer',
      'deleteCustomers',
      'loadCustomers',
      'loadCatalog',
      'actionCustomer',
      'setModalVisible',
      'setModalEmployeeVisible',
      'setModalShowEmployeeVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    changeOrderBy (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilter(data)
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.add_customer_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'customers.store') > -1
    },
    showEmployers (customer) {
      this.employeershow = {
        name: customer.name,
        user_id: customer.user_id,
        id: customer.id
      }
      this.setModalShowEmployeeVisible(true)
      // this.flags.map((value, index) => {
      //  index === position ? this.flags[position] = !this.flags[position] : this.flags[index] = false
      // })
    },
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.customers.findIndex(u => u.id === this.selected[0].id)
      this.editUser(this.selected[0], idx)
    },
    addEmployee (customer) {
      this.isModalAdd = true
      this.setModalEmployeeVisible(true)
      this.form = {
        name: customer.name,
        user_id: customer.user_id,
        id: customer.id,
        website: customer.website
      }
    },
    addCustomer () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.form = {}
    },
    editCustomer (customer, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.form = { ...customer }
    },
    async deleteCustomerConfirm (customer) {
      let t = this
      this.auxDeleteCustomer = () => {
        t.deleteCustomer(customer).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: this.$t(customer.contact) }),
        accept: this.auxDeleteCustomer
      })
    },
    async deleteCustomersConfirm () {
      let t = this
      let customersMany = parseDeleteMany(this.selected, 'contact')
      this.auxDeleteCustomer = () => {
        t.deleteCustomers(customersMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: customersMany.values }),
        accept: this.auxDeleteCustomer
      })
    },
    async setActionCustomer (record, action) {
      record.id && this.actionCustomer({ id: record.id, action })
    },
    async getCustomers (page) {
      let t = this
      this.loadCustomers({ page: page, customerId: '' }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let customer = this.customers.filter(customer => customer.id === parseInt(index))[0]
      customer && this.editCustomer(customer, index)
    },
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    getVariables () {
      this.flags = []
      this.customers.map((customer, index) => {
        this.flags[index] = false
      })
    }
  },
  computed: {
    ...mapGetters([
      'customers',
      'customersCatalog',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, ${t.$t('customers.' + column)}` : `${str} ${t.$t('customers.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.customer'), columns: concatColumns, column: this.$t('customers.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getCustomers(currentPage)
    },
    filterParams (filter) {
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getCustomers(this.currentPage)
    },
    customers (customers) {
      this.getVariables()
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
